import VisualData from './VisualData';

export default VisualData;
